import { useDispatch, useSelector } from 'react-redux';
import Constants from '../../constants';
import { AudienceStatus, SurveyStatusType } from '../../models';
import { IApplicationState } from '../../store';
import { NavigationActions } from '../../store/NavigationActions';

export const useAudienceAdminCards = (surveyId: number, audienceId: number) => {
	const dispatch = useDispatch();
	const { surveyAdminSummary, audiences } = useSelector((state: IApplicationState) => state.surveyAdmin);

	const hasBeenPublished = surveyAdminSummary ? surveyAdminSummary.hasBeenPublished : false;
	const audience = audiences.find((a) => a.audienceId === audienceId);
	const hasBeenCancelled = getCancelledStatus();

	function getCancelledStatus() {
		return audience?.audienceStatus === AudienceStatus.Cancelled || surveyAdminSummary?.surveyStatus === SurveyStatusType.Cancelled;
	}

	const navigate = (subRoute: string) => () => {
		dispatch(NavigationActions.Navigate(Constants.ROUTE_SURVEY_ADMIN, surveyId, `audience/${audienceId}/${subRoute}`));
	};

	return {
		dispatch,
		surveyAdminSummary,
		hasBeenPublished,
		hasBeenCancelled,
		navigate,
		isClosed: audience?.isClosed,
		distributionType: audience?.distributionType,
		audienceSourceType: audience?.audienceSourceType,
		audienceStatus: audience?.audienceStatus,
		numAudiences: audiences.length,
	};
};
